import { notification } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import moment from "moment"
import React, { useEffect, useMemo, useState } from "react"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { MdAdd, MdDelete, MdEdit, MdSend } from "react-icons/md"
import { SiTicktick } from "react-icons/si"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Swal from "sweetalert2"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { RiArrowUpDownFill } from "react-icons/ri"

const Roles = () => {
  document.title = "Roles | Return First Investments"

  const { checkAccess } = usePermissionData()

  const Navigate = useNavigate()

  const [Data, setData] = useState([])
  const [Users, setUsers] = useState([])
  const [Loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`roles-and-permissions`)
      if (response?.data?.success) {
        setUsers(response?.data?.data)
        setData(response?.data?.data.reverse())
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Users.filter(session =>
      session.roleName.toLowerCase().includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const handleDelete = async id => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Role",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    })

    if (result.isConfirmed) {
      try {
        const response = await axiosbaseurl.delete(
          `/roles-and-permissions/${id}`
        )

        if (response?.data?.success) {
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">Role Deleted Successfully.</div>
              </div>
            ),
            placement: "topRight",
          })

          getData()
        }
      } catch (error) {
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: error?.response?.data?.message,
        })
      }
    }
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  // Sort logic with memoization
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return Data

    const sortableItems = [...Data]

    sortableItems.sort((a, b) => {
      let aValue = a[sortConfig.key]
      let bValue = b[sortConfig.key]

      // If sorting by date, convert to timestamp
      if (sortConfig.key === "createdAt") {
        aValue = new Date(aValue).getTime()
        bValue = new Date(bValue).getTime()
      } else if (typeof aValue === "string" && typeof bValue === "string") {
        aValue = aValue.toLowerCase()
        bValue = bValue.toLowerCase()
      }

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sortableItems
  }, [Data, sortConfig])

  // Pagination on sorted data
  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  // Request sorting and toggle direction
  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(5, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Roles & Permissions"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between">
                <div className="search-box position-relative">
                  <input
                    className="form-control ps-6"
                    placeholder="Search Role"
                    onChange={filterByName}
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>

                <div>
                  {checkAccess(5, 2) && (
                    <button
                      className="btn Add-Button rounded-5 mt-2 mt-xl-0"
                      onClick={() => Navigate(`${ConfigUrl.appurl}add-role`)}
                    >
                      <MdAdd /> Add Role
                    </button>
                  )}
                </div>
              </div>

              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>

                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("roleName")}
                      >
                        Role Name{" "}
                        {sortConfig.key === "roleName" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>

                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("createdAt")}
                      >
                        Created At{" "}
                        {sortConfig.key === "createdAt" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>

                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      final_data.length === 0 && (
                        <tr>
                          <td colSpan={4}>No Role Found</td>
                        </tr>
                      )
                    }
                    {final_data?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.roleName}</td>
                        <td>
                          {moment(item?.createdAt).format(
                            "DD MMMM YYYY | HH:mm A"
                          )}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center">
                            {checkAccess(5, 3) && (
                              <button
                                className="btn Edit-Button me-2 rounded-5"
                                onClick={() =>
                                  Navigate(
                                    `${ConfigUrl.appurl}edit-role/${item?.id}`
                                  )
                                }
                              >
                                <MdEdit /> Edit
                              </button>
                            )}
                            {checkAccess(5, 4) && (
                              <button
                                className="btn delete-Button rounded-5"
                                onClick={() => handleDelete(item?.id)}
                              >
                                <MdDelete /> Delete
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-6">
                  Showing {final_data?.length} out of {Data?.length} roles.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default Roles
